export const regex = {
  spaces: / +/gi,
  and: /&+/gi,
  slashes: /\/+/gi,
  not_digits: /[^0-9]+/gi,
  not_alpha: /[^-'a-zA-ZÀ-ÖØ-öø-ſ ]+/gi,
  not_date_chars: /[^0-9/]/gi,
  postal: /^(\d{5})-?(\d{1,3})/,
  tel: /^(\d{2})(\d{1,5})?(\d{4})?$/,
  rg: /^(\d{1,2})(\d{1,3})?(\d{1,3})?(\d{1,2})?$/,
  cnpj: /^(\d{2})(\d{1,3})?(\d{1,3})?(\d{1,4})?(\d{1,2})?/,
  cpf: /^(\d{1,3})?(\d{1,3})?(\d{1,3})?(\d{1,2})?/,
  date: /^(\d\/|\d{2})\/*(\d\/|\d{2})?\/*(\d{1,4})?/,
  sus: /^(\d{0,3}) ?(\d{0,4}) ?(\d{0,4}) ?(\d{0,4})$/,
  horario: /^(\d{2}):?(\d{1,2})/,
};

export const and = (val) => val
  .replace(regex.and, '');

export const name = (val) => val
  .replace(regex.not_alpha, '')
  .replace(regex.spaces, ' ');

export const cep = (val) => val
  .replace(regex.not_digits, '')
  .substr(0, 8)
  .replace(regex.postal, '$1-$2');

export const tel = (val) => val
  .replace(regex.not_digits, '')
  .substr(0, 11)
  .replace(regex.tel, (
    all, ddd, area, final,
  ) => (
    `${
      ddd ? `(${ddd}` : ''
    }${
      area ? `) ${area}` : ''
    }${
      final ? `-${final}` : ''
    }`
  ));

export const number = (val) => val
  .replace(regex.not_digits, '');

export const money = (val) => {
  const digits = number(val);

  if (digits.length < 3) {
    return digits;
  }

  const integer = digits.slice(0, digits.length - 2);
  const decimal = digits.slice(digits.length - 2);
  return `${integer},${decimal}`;
};

export const sus = (val) => val
  .replace(regex.not_digits, '')
  .substr(0, 15)
  .replace(regex.sus, (all, a, b, c, d) => (
    `${a || ''}${b ? ` ${b}` : ''}${c ? ` ${c}` : ''}${d ? ` ${d}` : ''}`
  ));

export const rg = (val) => val
  .replace(regex.not_digits, '')
  .substr(0, 10)
  .replace(regex.rg, (
    all, p1, p2, p3, p4,
  ) => {
    const lastChar = val.substr(-1, 1);
    const x = lastChar.toUpperCase() === 'X' ? '-X' : '';
    return `${
      p1 || ''
    }${
      p2 ? `.${p2}` : ''
    }${
      p3 ? `.${p3}` : ''
    }${
      p4 ? `-${p4}` : x
    }`;
  });

export const cnpj = (val) => val
  .replace(regex.not_digits, '')
  .substr(0, 14)
  .replace(regex.cnpj, (
    all, p1, p2, p3, p4, p5,
  ) => `${
    p1 || ''
  }${
    p2 ? `.${p2}` : ''
  }${
    p3 ? `.${p3}` : ''
  }${
    p4 ? `/${p4}` : ''
  }${
    p5 ? `-${p5}` : ''
  }`);

export const cpf = (val) => val
  .replace(regex.not_digits, '')
  .substr(0, 11)
  .replace(regex.cpf, (
    all, p1, p2, p3, p4,
  ) => `${
    p1 || ''
  }${
    p2 ? `.${p2}` : ''
  }${
    p3 ? `.${p3}` : ''
  }${
    p4 ? `-${p4}` : ''
  }`);

export const isCNPJ = (val) => (
  val.replace(regex.not_digits, '').length > 11
);

export const cpfcnpj = (val) => (
  isCNPJ(val) ? cnpj(val) : cpf(val)
);

export const tenify = (str) => {
  if (str === null || typeof str === 'undefined') {
    return '';
  }
  const n = str.replace(regex.slashes, '');
  if (n.toString().length === 1 && Number(n) > 0) {
    return `0${n}`;
  }
  return n;
};

export const date = (val) => {
  const dateString = val instanceof Date
    ? `${val.getDate()}/${val.getMonth() + 1}/${val.getFullYear()}`
    : val;
  return dateString
    .replace(regex.slashes, '/')
    .replace(regex.not_date_chars, '')
    .replace(regex.date, (
      all, dd, mm, yyyy,
    ) => `${
      tenify(dd) || ''
    }${
      mm ? `/${tenify(mm)}` : ''
    }${
      yyyy ? `/${yyyy}` : ''
    }`)
    .substr(0, 10);
};

export const time = (val) => val.replace(regex.not_digits, '').substr(0, 4).replace(regex.horario, (e, r, a) => (r || '') + (a ? `:${a}` : ''));

export const email = (val) => val.toLowerCase();

export const isEmail = (val) => String(val)
  .toLowerCase()
  .match(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  );
